import React, { useEffect, useRef, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import Task from './Task';
import { TaskContext, PermissionContext } from './../context';
import { useDrop, useDrag } from 'react-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import services from '../services';
import { boardLocal } from '../utils/LocalSt';
import ConfirmationPopup from './ConfirmationPopup';
import { columnsLocal } from '../utils/LocalSt';
import { AddColumnCall, addColumnsDetails, addForm, getCurrentTask, removeForm, updateForm } from '../Redux/slice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useTaskData } from '../hooks/useTaskData';
import { v4 as uuidv4 } from 'uuid';
import { getLocalStorageItem, setLocalStorageItem } from '../utils/Localstorage/localStorageUtils';
import permission from '../api/permission';
import AllAutomation from './Automation/AllAutomation';
import { Tooltip } from 'react-tooltip';
import Automations from './Automation/Automations'
import IncomingMail from './Automation/IncomingMail';
import AllIncomingAutomation from './Automation/AllIncomingAutomation';
function Column(props) {
    const {
        columnTitle,
        limit,
        id,
        borderColor,
        showkey,
        setStatusUpdate,
        statusUpdate,
        taskDetailsPopup,
        setTaskDetailsPopup,
        getTaskMail,
        taskMail,
        taskAssign,
        setSearchTerm,
        index,
        columnMove,
        columnID,
        searchTerm,
        isShiftPressed,
        moveChildTask,
        handleRemoveChild,
        setIsShiftPressed,
        setConData,
        setColumnAddStatus,
        handleUpdateTask,
        selectedMyDayPlanDate,
        setSelectedMyDayPlanDate,
        selectedReminderDate,
        setSelectedReminderDate,
        selectedStatusNextStepDate,
        setSelectedStatusNextStepDate,
        note,
        setNote,
        handleDateSelect,
        myDayDate,
        deadlineDate,
        isMyDayChecked,
        isDeadlineChecked,
        setIsMyDayChecked,
        notesText,
        setNotesText,
        setIsDeadlineChecked,
        setMyDayDate,
        setDeadlineDate,
        selectedBoardId,
        toggleTaskDropdown,
        editTaskTitle,
        setEditTaskTitle,
        selectedTaskcolor,
        setSelectedTaskcolor,
        isOpen,
        openTaskId,
        setIsOpen,
        taskDeleteId,
        showBox,
        setShowBox,
        setIsSearchBoxOpen,
        setHoverIndex,
        setColorIndexID,
        setActivePatch,
        hoverIndex,
        colorIndexID,
        activePatch,
        handleEditTitle,
        clearHighlight,
        handleClick,
        setUpdateTitle,
        updateTitle,
        setIsOpenDeadline,
        isOpenDeadline,
        isSearchBoxOpen,
        deleteTask,
        taskToDelete,
        setTaskToDelete,
        handleCancelDelete,
        setTaskMail,
        getAllBoard,
        activeButton,
        isArchivedBoard,
        supervisorActions,
        onColumnScrollEnd,
        boardName,
        filterList,
        isMember,
        parentOrigin,
        columnAutomation,
        allCustomFieldList,
        setAllCustomFieldList,
        getAllAutomation
    } = props;

    const { permissions } = useContext(PermissionContext);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [renameMode, setRenameMode] = useState(false);
    const [newTitle, setNewTitle] = useState(columnTitle);
    const [automations, setAutomations] = useState(false);
    const [incomingEmailAutomation, setIncomingEmailAutomation] = useState(false);
    const [step, setStep] = useState(1);
    const [columnStep, setColumnStep] = useState(1);
    const [editId, setEditId] = useState(null);
    const [columneditId, setColumnEditId] = useState(null);
    const [columnAutomations, setColumnAutomations] = useState(false)
    const dispatch = useDispatch();
    const permittedItems = [
        { name: 'Add a task', permission: permissions.addTask },
        { name: 'Add a list', permission: permissions.addList },
        { name: 'Rename this list', permission: permissions.renameList },
        { name: 'Delete this list', permission: permissions.deleteList },
        { name: 'Archieve all items in list', permission: true },
        { name: 'Create automation', permission: true },
        { name: 'Add incomings emails to this list', permission: true }
    ].filter(item => item.permission);
    const { columns, columnFormList, selectedTab } = useSelector(
        (state) => ({
            columns: state.redux.columns,
            columnFormList: state.redux.columnFormList,
            selectedTab: state.redux.selectedTab,
        }),
        (prev, next) =>
            prev.columns === next.columns &&
            prev.columnFormList === next.columnFormList &&
            prev.selectedTab === next.selectedTab,
    );

    const forms = (columnFormList || []).filter((f) => f.columnID === columnID);
    const [userName, setUserName] = useState('');
    const columnsData = columnsLocal();
    const [deleteShowBox, setDeleteShowBox] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');
    const formRefs = React.useRef({});
    const [taskDetailsModal, setTaskDetailModal] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState('');
    const [currentTask, setCurrentTask] = useState(null);
    const clickTimeoutRef = useRef(null);
    const ignoreNextClickRef = useRef(false);
    const [hasColumnAutomation, setHasColumnAutomation] = useState(false);
    const [matchedGmailList, setMatchedGmailList] = useState([]);
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const setColumnAutomation = async (columnAutomation) => {
        if (!Array.isArray(columnAutomation) || !columnID) {
            setHasColumnAutomation(false);
            setMatchedGmailList([]);
            return;
        }
    
        const matched = columnAutomation.filter(auto => {
            const createAction = auto.action?.find(
                a => a.action === "createOnList"
            );
            return createAction?.entityId === columnID;
        });
    
        if (matched.length > 0) {
            setHasColumnAutomation(true);
    
            const gmailList = matched
                .map(m => {
                    const gmailUserId = m.when?.gmailUserId; // string id
                    const matchedUser = filterList.find(
                        u => u.value === gmailUserId
                    );
                    return matchedUser?.label;
                })
                .filter(Boolean);
    
            setMatchedGmailList(gmailList);
        } else {
            setHasColumnAutomation(false);
            setMatchedGmailList([]);
        }
    };
        
    

    useEffect(() => {
        setColumnAutomation(columnAutomation)
    }, [columnAutomation])

    const navigate = useNavigate();
    const {
        moduleName,
        moveTaskToColumn,
        removeTask,
        moveTaskUp,
        moveTaskDown,
        updateColunTitleInLocalStorage,
        getTaskMailIndbox,
    } = React.useContext(TaskContext);

    const archiveAllTasks = async (columnID) => {


        try {
            await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateByColumnId/${columnID}`, {
                boardId: selectedBoardId,
            });
            toast.success('All tasks in the column have been archived.');
            getTaskMail(1, '', selectedBoardId);
            setIsDropdownOpen(false);
        } catch (error) {
            console.error('Error archiving all tasks in column:', error);
            toast.error('Failed to archive all tasks in the column.');
        }
    };
    useEffect(() => {
        if (!selectedBoardId) {
            const savedBoard = getLocalStorageItem('board')
            if (savedBoard) {
                try {
                    const parsedBoard = savedBoard;
                } catch (error) {
                    console.error('Error parsing saved board:', error);
                }
            }
        }
    }, [selectedBoardId]);

    const createTask = async (selectedStatus, title) => {
        const dataObj = {
            boardListId: selectedStatus,
            title: title,
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/task/createTask`, dataObj);
            if (response && selectedBoardId) {
                getTaskMail(1, {}, selectedBoardId);
            }
        } catch (error) {
            console.error('Error creating task:', error);
        }
    };

    const createTaskMail = async (
        gmailMessageID,
        gmailStatus,
        subjectTitle,
        typeOf,
        boardId,
        subThreadId,
        columnIndex,
        selectedBoardId
    ) => {
        let finalBoardId = boardId;
        if (!finalBoardId) {
            finalBoardId = selectedBoardId;
        }

        if (!finalBoardId) {
            const savedBoard = getLocalStorageItem('board')
            if (savedBoard) {
                try {
                    const parsedBoard = savedBoard;
                    finalBoardId = parsedBoard.value;
                } catch (error) {
                    console.error('Error parsing saved board:', error);
                }
            }
        }

        if (!finalBoardId) {
            console.error('No board ID available for creating task');
            toast.error('Please select a board before creating a task');
            return;
        }

        let dataObj = {
            boardListId: gmailStatus,
            title: subjectTitle,
            taskType: typeOf ? typeOf : 'Gmail',
            boardId: finalBoardId,
        };
        if (subThreadId !== undefined && subThreadId !== null) {
            dataObj.subThreadId = subThreadId;
        }
        if (typeOf === 'Whatsapp') {
            dataObj = {
                ...dataObj,
                contactId: gmailMessageID,
            };
        } else {
            dataObj = {
                ...dataObj,
                gmailMessageId: gmailMessageID,
            };
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/task/createTask`, dataObj, {
                headers: {
                    Authorization: `Bearer ${localStorage?.getItem('access_token')}`,
                },
            });
            updateStatusTask(response?.data?.data?.id, boardId);
            if (response && boardId) {
                getAllTaskMail(columnIndex, response?.data?.data?.id, boardId);
                // getTaskMailIndbox();
            }
        } catch (error) {
            console.error('Error creating task mail:', error);
        }
    };

    const getGmailUsers = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            if (response?.data) {
                const gmailOptions = response.data.map((item) => ({
                    value: item.id,
                    label: item.email,
                }));
                setFilterList(gmailOptions);
            }
        } catch (error) {
            console.error('Error fetching Gmail users:', error);
        }
    };
    useEffect(() => {
        if (!renameMode) return;
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setRenameMode(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [renameMode]);

    const getAllTaskMail = async (columnIndex, taskId, selectedBoardId) => {
        const query = {
            limit: 800,
            boardId: selectedBoardId,
        };

        if (activeButton == 'table') {
            query.sortBy = sortby;
            query.sortOrder = sortOrder;
            query.query = 'table';
        }

        const obj = new URLSearchParams(query);

        try {
            const response = await services.task.GET_TASK(obj);
            if (response) {
                let data = JSON.parse(JSON.stringify(response?.data?.data));
                const allTaskData = data[columnID] || [];

                moveTask(taskId, columnID, columnIndex, allTaskData, 'task', selectedBoardId);
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
        }
    };
    const updateStatusTask = async (id, boardId) => {
        const data = {
            boardListId: columnID,
        };
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${id}`, data);
            if (response && boardId) {
                getTaskMail(1, {}, boardId);
            }
        } catch (error) {
            console.error('Error updating task status:', error);
        }
    };

    const updateStatusEmail = async (id) => {
        const data = {
            gmailStatus: columnTitle,
        };
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/email/updateStatusEmail/${id}`,
                data,
            );
            if (response) {
                const gmailMessageId = response?.data?.data?.gmailMessageId;
                const gmailStatus = response?.data?.data?.gmailStatus;
                const subjectTitle = response?.data?.data?.subject;
                createTaskMail(gmailMessageId, gmailStatus, subjectTitle);
                getTaskMailIndbox();
                getTaskMail();
            }
        } catch (error) {
            console.error('Error updating email status:', error);
        }
    };

    const [{ isOver }, drop] = useDrop(() => ({
        accept: 'task',
        drop: (item) => {
            const targetColumn = columnID;
            const sourceColumn = item?.columnID;
            item?.taskStatus && setStatusUpdate(!statusUpdate);

            let boardId = selectedBoardId;
            if (!boardId) {
                const savedBoard = getLocalStorageItem('board')
                if (savedBoard) {
                    try {
                        const parsedBoard = savedBoard;
                        boardId = parsedBoard.value;
                    } catch (error) {
                        console.error('Error parsing saved board:', error);
                    }
                }
            }
            if (boardId) {
                // if (targetColumn !== sourceColumn) {
                //     let boardId = selectedBoardId;

                //     if (item?.gmailMessageId === null ) {
                //         alert()
                //         createTaskMail(
                //             item?.gmailMessage,
                //             targetColumn,
                //             item?.title || item?.subject,
                //             item?.typeOf,
                //             boardId,
                //             '',
                //             item?.indexId,
                //             item?.gmailMessage
                //         );
                //     }else{

                //     }

                //     item.columnID = targetColumn;
                // } else {
                // }
            }
            if (item?.gmailMessage) {
                if (!boardId) {
                    const savedBoard = getLocalStorageItem('board')
                    if (savedBoard) {
                        try {
                            const parsedBoard = savedBoard;
                            boardId = parsedBoard.value;
                        } catch (error) {
                            console.error('Error parsing saved board:', error);
                        }
                    }
                }

                if (boardId) {
                    const subThreadId = item?.subThreadId;
                    if (subThreadId !== undefined && subThreadId !== null) {
                        createTaskMail(
                            item?.gmailMessage,
                            columnID,
                            '',
                            item?.typeOf,
                            boardId,
                            subThreadId,
                            item?.indexId,
                            item?.gmailMessage,
                        );
                    } else {
                        createTaskMail(
                            item?.gmailMessage,
                            columnID,
                            item?.subject,
                            item?.typeOf,
                            boardId,
                            '',
                            item?.indexId,
                            item?.gmailMessage,
                        );
                    }
                } else {
                    console.error('No board ID available for dropping task');
                    toast.error('Please select a board before dropping items');
                }
            }
            updateStatusTask(item?.id, boardId);
        },
    }));

    const handleKeyDown = (e, formId) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const form = forms.find((f) => f.id === formId);
            if (form && form.title) {
                createTask(columnID, form.title);
                dispatch(removeForm(formId));
            }
        }
    };

    const handleRenameClick = () => {
        setRenameMode(true);
        setIsDropdownOpen(false);
    };

    const handleColumnKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleRenameColumn();
            setRenameMode(false);
        }
    };

    const [{ isDragging }, dragRef] = useDrag({
        type: 'COLUMN',
        item: { index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const [, dropRef] = useDrop({
        accept: 'COLUMN',
        hover: (draggedItem) => {
            if (draggedItem.index !== index) {
                columnMove(draggedItem.index, index);
                draggedItem.index = index;
            }
        },
    });

    const ref = React.useRef(null);
    dragRef(dropRef(ref));
    const localSt = getLocalStorageItem('board')

    const handleRenameColumn = async () => {
        const data = { coloum: newTitle, boardId: localSt?.value };
        try {
            const response = await services?.column?.RENAME_COLUMN(data, columnID);
            const updatedColumns = columns?.length > 0 && columns.map((column) => {
                if (column.id === columnID) {
                    return { ...column, title: newTitle };
                }
                return column;
            });
            dispatch(addColumnsDetails(updatedColumns));
            setRenameMode(false);
            const colId = response?.data?.data?.id;
            await services.board.SELECTED_BOARD(colId);
        } catch (e) {
            console.error(e);
            toast.error('Failed to rename list.');
        }
    };

    const [boradList, setBoardList] = useState([]);
    const getAllBoardDateTable = async () => {
        try {
            const response = await services.board.GET_BOARD_LIST();
            setBoardList(response?.data?.data);
        } catch (error) {
            console.error('❌ Error fetching board date table:', error);
        }
    };

    useEffect(() => {
        getAllBoardDateTable();
    }, []);

    const deleteTaskMail = async () => {
        if (columns.length <= 1) {
            toast.error(
                "You can't delete the last list on your board. You can rename this list if you want to change its heading.",
            );
            return;
        }
        const tasksInColumn = (taskMail[columnID] || []).filter(
            (item) => item?.BoardList?.id === columnID
        );

        if (tasksInColumn.length > 0) {
            toast.error("You can't delete this Column. It has tasks in it please move them to another column.");
            return;
        }


        try {
            const response = await services.column.DELETE_COLUMN(columnID);
            if (response) {
                const filterData = columns?.length > 0 && columns.filter(({ id }) => id !== columnID);
                if (filterData.length === 0) {
                    toast.error(
                        "You can't delete the last list on your board. You can rename this list if you want to change its heading.",
                    );
                    return;
                }

                const updatedFilterData = filterData?.length > 0 && filterData.map((column, index) => ({
                    ...column,
                    sequence: index + 1,
                }));

                dispatch(addColumnsDetails(updatedFilterData));

                setLocalStorageItem('columns', updatedFilterData)
                setConData(updatedFilterData);

                const boradListFilter = boradList?.length > 0 && boradList?.filter((item) => item?.id === selectedBoardId);
                const boardListsArray = boradListFilter?.[0]?.BoardLists || [];

                const updatedBoardListsArray = boardListsArray
                    .filter((item) => item.id !== columnID)
                    .map((item, index) => ({
                        ...item,
                        sequence: index + 1,
                    }));

                await services.board.SEQUENCE(updatedBoardListsArray, selectedBoardId);

                setDeleteShowBox(false);
            }
        } catch (error) {
            console.error('Error deleting column:', error);
            toast.error('Failed to delete the column.');
        }
    };

    const [lastAddedTaskId, setLastAddedTaskId] = useState(null);
    const [lastAddedSource, setLastAddedSource] = useState(null);
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const addNewForm = async (source) => {
        const newForm = {
            boardListId: columnID,
            title: 'type your task name here',
            taskType: selectedTab == 'GMAIL' || selectedTab == 'GMAIL_BOARD' ? 'Gmail' : 'Whatsapp',
            boardId: selectedBoardId,
        };

        try {
            const response = await services.task.CREATE_TASK(newForm);

            if (response) {
                const newTask = response.data.data;
                const currentTasks = taskMail[columnID] || [];
                let newTasks;

                if (source === 'Add a task') {
                    newTasks = [newTask, ...currentTasks];
                } else {
                    newTasks = [...currentTasks, newTask];
                }

                setTaskMail((prevTaskMail) => ({
                    ...prevTaskMail,
                    [columnID]: newTasks,
                }));

                if (source === 'Add a task') {
                    const beforeTaskId = currentTasks.length > 0 ? currentTasks[0].id : null;
                    const payload = {
                        taskId: newTask.id,
                        beforeTaskId: beforeTaskId,
                        afterTaskId: null,
                        boardListId: columnID,
                    };
                    await services.task?.MOVE_TASK_DRAG_DROP(payload);
                }
            }
        } catch (error) {
            console.error('Error creating task mail:', error);
            toast.error('Failed to create task. Please try again.');
        }
    };

    const updateFormTitle = (formId, title) => {
        dispatch(updateForm({ id: formId, title }));
    };

    const closeForm = (formId) => {
        dispatch(removeForm(formId));
    };

    let clickTimeout = null;

    const handleSingleClick = (item, e, isForm) => {
        if (ignoreNextClickRef.current) {
            ignoreNextClickRef.current = false;
            return;
        }

        if (e.target.closest('[data-no-popup]')) return;

        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current);
        }

        clickTimeoutRef.current = setTimeout(() => {
            if (!ignoreNextClickRef.current) {
                handleTaskDetailPopup(item, e, isForm);
            }
        }, 300);
    };

    const handleTaskDetailPopup = (item, event, isForm) => {
        if (item) {
            navigate(`/detail/${item.id}`, {
                state: {
                    selectedMail: item,
                    deadlineDate: deadlineDate,
                    taskID: item.id,
                    clickMailTask: true,
                    type: 'Gmail',
                    openTaskDataSidebar: true,
                    currentTask: item,
                    boardId: selectedBoardId,
                    boardName: boardName,
                    isMember: isMember,
                    parentOrigin: parentOrigin
                },
            });
        } else if (item.Email == undefined) {
            setTaskDetailModal(true);
        } else {
            setTaskDetailModal(false);
            setCurrentTask(item);
            dispatch(getCurrentTask(item));
        }
    };

    const taskData = useTaskData();

    let tasksInColumn = Array.isArray(taskMail) ? taskMail.filter((item) => item?.BoardList?.id === columnID) : [];

    if (lastAddedTaskId && lastAddedSource && tasksInColumn.some((t) => t.id === lastAddedTaskId)) {
        const idx = tasksInColumn.findIndex((t) => t.id === lastAddedTaskId);
        const [lastTask] = tasksInColumn.splice(idx, 1);
        if (lastAddedSource === 'Add a task') {
            tasksInColumn = [lastTask, ...tasksInColumn];
        } else if (lastAddedSource === 'column-list') {
            tasksInColumn = [...tasksInColumn, lastTask];
        }
    }
    const moveTaskToIndex = (taskId, toIndex) => {
        const tasks = [...taskMail[columnID]];
        const fromIndex = tasks.findIndex((task) => task.id === taskId);
        if (fromIndex === -1 || fromIndex === toIndex) return;
        const [movedTask] = tasks.splice(fromIndex, 1);
        tasks.splice(toIndex, 0, movedTask);

        setTaskMail((prev) => ({
            ...prev,
            [columnID]: tasks,
        }));

        moveTask(taskId, columnID, toIndex, tasks);
    };
    const moveTaskInState = (fromIndex, toIndex, colId) => {
        if (fromIndex === toIndex) return;
        setTaskMail((prev) => {
            const columnTasks = [...prev[colId]];
            const [moved] = columnTasks.splice(fromIndex, 1);
            columnTasks.splice(toIndex, 0, moved);
            return { ...prev, [colId]: columnTasks };
        });
    };

    const moveTaskToOtherColumnInState = (fromIndex, toIndex, fromColumnId, toColumnId, movedTask) => {
        setTaskMail((prev) => {
            const sourceTasks = [...(prev[fromColumnId] || [])];
            const targetTasks = [...(prev[toColumnId] || [])];

            sourceTasks.splice(fromIndex, 1);
            targetTasks.splice(toIndex, 0, movedTask);

            return {
                ...prev,
                [fromColumnId]: sourceTasks,
                [toColumnId]: targetTasks,
            };
        });
    };

    const moveTask = async (dragTaskId, toColumnId, toIndex, updatedTasks, type, boardId) => {
        let beforeTaskId = null;
        let afterTaskId = null;
        if (toIndex === 0) {
            beforeTaskId = updatedTasks[1]?.id || null;
        } else if (toIndex === updatedTasks.length - 1) {
            afterTaskId = updatedTasks[updatedTasks.length - 2]?.id || null;
        } else {
            afterTaskId = updatedTasks[toIndex - 1]?.id || null;
            beforeTaskId = updatedTasks[toIndex + 1]?.id || null;
        }

        if (type === 'Manual-Task') {
            beforeTaskId = null;
        }

        const payload = {
            taskId: dragTaskId,
            beforeTaskId,
            afterTaskId,
            boardListId: toColumnId,
        };

        try {
            await services.task?.MOVE_TASK_DRAG_DROP(payload);
            if (boardId) {
                getTaskMail(1, {}, boardId);
            }
        } catch (error) {
            console.error('❌ Error in moveTask:', error);
        }
    };
    useEffect(() => {
        setNewTitle(columnTitle);
    }, [columnTitle, columnID]);

    const columnScrollRef = useRef(null);

    useEffect(() => {
        const el = columnScrollRef.current;
        if (!el) return;
        const onScroll = () => {
            const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 40;
            if (nearBottom && typeof onColumnScrollEnd === 'function') {
                onColumnScrollEnd();
            }
        };
        el.addEventListener('scroll', onScroll, { passive: true });
        return () => el.removeEventListener('scroll', onScroll);
    }, [onColumnScrollEnd]);


    return (
        <>
            <div
                ref={ref}
                style={{
                    opacity: isDragging ? 0.5 : 1,
                    cursor: 'move',
                    textAlign: 'center',
                    position: 'relative',
                    minWidth: '350px',
                }}
            >
                <div className="droptarget" style={{ backgroundColor: isOver ? 'lightgrey' : 'white' }}>
                    <div className="title-contents drop-relative flex-col mt-1" >
                        <div className="header-Flex">
                            <h2 className="title-column title-box" style={{ borderBottomColor: borderColor }} onDoubleClick={() => setRenameMode(true)}>
                                {renameMode ? (
                                    <input
                                        type="text"
                                        value={newTitle}
                                        onChange={(e) => setNewTitle(e.target.value)}
                                        onKeyDown={handleColumnKeyDown}
                                        onBlur={() => {
                                            handleRenameColumn();
                                            setRenameMode(false);
                                        }}

                                        autoFocus
                                    />
                                ) : (
                                    <span>{newTitle}</span>
                                )}
                            </h2>
                            {!showkey && (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#000"
                                    onClick={toggleDropdown}
                                    className="bi bi-chevron-down down-arrow-circle"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                    />
                                </svg>
                            )}
                        </div>
                        {hasColumnAutomation && <div onClick={() => setIncomingEmailAutomation(true)} style={{ cursor: "pointer" }} class="d-flex align-items-center bg-light rounded px-2 py-1">
                            <i class="bi bi-caret-down-fill me-2 text-secondary small"></i>
                            <span class="small">
                                Emails incoming from
                                <a
                                    className="link-primary text-decoration-none fw-medium ms-1"
                                    data-tooltip-id="matched-email-tooltip"
                                    data-tooltip-content={matchedGmailList.join(", ")}
                                >
                                    {matchedGmailList.length > 1
                                        ? `${matchedGmailList[0]} ...`
                                        : matchedGmailList[0] || "N/A"}
                                </a>

                            </span>
                        </div>}
                        {isDropdownOpen && permittedItems.length > 0 && (
                            <div>
                                <div onClick={toggleDropdown} className="layout-backdrop"></div>
                                <div className="headtag-card" style={{ cursor: 'pointer' }}>
                                    <ul className="start-list">
                                        {permittedItems.map((item, index) => (
                                            <li key={index}>
                                                <a
                                                    onClick={() => {
                                                        if (item.name === 'Add a task') {
                                                            addNewForm('Add a task');
                                                            setIsDropdownOpen(false);
                                                        } else if (item.name === 'Rename this list') {
                                                            handleRenameClick();
                                                        } else if (item.name === 'Create automation') {
                                                            setAutomations(!automations)
                                                        } else if (item.name === 'Delete this list') {
                                                            const tasksInColumn = taskMail?.[columnID] || [];

                                                            if (tasksInColumn.length > 0) {
                                                                setDeleteMessage(
                                                                    "You can't delete this Column. It has tasks in it please move them to another column.",
                                                                );
                                                                setDeleteShowBox(true);
                                                                setIsDropdownOpen(false);
                                                            } else {
                                                                setDeleteShowBox(true);
                                                                setIsDropdownOpen(false);
                                                            }
                                                        } else if (item.name === 'Add a list') {
                                                            setColumnAddStatus(true);
                                                            dispatch(AddColumnCall());
                                                        } else if (item.name === 'Archieve all items in list') {
                                                            archiveAllTasks(columnID);
                                                        } else if (item.name === 'Add incomings emails to this list') {

                                                            if (columnAutomation.length > 0) {
                                                                 setColumnStep(1)
                                                                setIncomingEmailAutomation(true);
                                                            } else {
                                                                setColumnStep(2)
                                                                setColumnAutomations(true)
                                                            }
                                                        }
                                                    }}
                                                > {item.name === 'Add a task' && <div className=""></div>}
                                                    {item.name === 'Add a list' && <div className=""></div>}
                                                    {item.name === 'Rename this list' && <div className=""></div>}
                                                    {item.name === 'Delete this list' && <div className=""></div>}
                                                    {item.name === 'Mark all items in list complete' && (
                                                        <div className=""></div>
                                                    )}
                                                    {/* {item.name === 'Archieve all items in list' && (
                                                        <div className="underline-list"></div>
                                                    )} */}
                                                    {item.name === 'Add incomings emails to this list' && (
                                                        <div className=""></div>
                                                    )}
                                                    {item.name === 'Create automation' && <div></div>}
                                                    <div className="currentDay">
                                                        {item.name && item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                                                        <div>{item.dayName}</div>
                                                    </div>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>

                    <div
                        ref={(node) => {
                            columnScrollRef.current = node;
                            drop(node);
                        }}
                        style={{ opacity: isOver ? 0 : 1 }}
                        className="inbox-Task-scroll"
                    >
                        {taskMail &&
                            (taskMail[columnID] || []).map((item, indexId) => (
                                <Task
                                    parentOrigin={parentOrigin}
                                    isMember={isMember}
                                    key={item.id}
                                    item={item}
                                    moveTaskToColumn={moveTaskToColumn}
                                    moveTaskUp={moveTaskUp}
                                    moveTaskDown={moveTaskDown}
                                    removeTask={removeTask}
                                    indexId={indexId}
                                    getTaskMail={getTaskMail}
                                    showForm={forms.length > 0}
                                    columnTitle={columnTitle}
                                    setTaskDetailsPopup={setTaskDetailsPopup}
                                    taskDetailsPopup={taskDetailsPopup}
                                    taskDeadline={item.deadline}
                                    userAssigneeName={item?.userId}
                                    taskColor={item?.color}
                                    taskAssign={taskAssign}
                                    setSearchTerm={setSearchTerm}
                                    searchTerm={searchTerm}
                                    isShiftPressed={isShiftPressed}
                                    moveChildTask={moveChildTask}
                                    columnID={columnID}
                                    handleRemoveChild={handleRemoveChild}
                                    setIsShiftPressed={setIsShiftPressed}
                                    getTaskMailIndbox={getTaskMailIndbox}
                                    setSelectedMyDayPlanDate={setSelectedMyDayPlanDate}
                                    selectedMyDayPlanDate={selectedMyDayPlanDate}
                                    handleUpdateTask={handleUpdateTask}
                                    selectedReminderDate={selectedReminderDate}
                                    setSelectedReminderDate={setSelectedReminderDate}
                                    selectedStatusNextStepDate={selectedStatusNextStepDate}
                                    setSelectedStatusNextStepDate={setSelectedStatusNextStepDate}
                                    note={note}
                                    setNote={setNote}
                                    handleDateSelect={handleDateSelect}
                                    myDayDate={myDayDate}
                                    deadlineDate={deadlineDate}
                                    isMyDayChecked={isMyDayChecked}
                                    isDeadlineChecked={isDeadlineChecked}
                                    setIsMyDayChecked={setIsMyDayChecked}
                                    setIsDeadlineChecked={setIsDeadlineChecked}
                                    notesText={notesText}
                                    setNotesText={setNotesText}
                                    setMyDayDate={setMyDayDate}
                                    setDeadlineDate={setDeadlineDate}
                                    handleSingleClick={handleSingleClick}
                                    handleTaskDetailPopup={handleTaskDetailPopup}
                                    taskDetailsModal={taskDetailsModal}
                                    setTaskDetailModal={setTaskDetailModal}
                                    currentTask={currentTask}
                                    setCurrentTask={setCurrentTask}
                                    toggleTaskDropdown={toggleTaskDropdown}
                                    editTaskTitle={editTaskTitle}
                                    setEditTaskTitle={setEditTaskTitle}
                                    selectedTaskcolor={selectedTaskcolor}
                                    setSelectedTaskcolor={setSelectedTaskcolor}
                                    isOpen={openTaskId === item.id}
                                    setIsOpen={setIsOpen}
                                    taskDeleteId={taskDeleteId}
                                    showBox={showBox}
                                    setShowBox={setShowBox}
                                    setIsSearchBoxOpen={setIsSearchBoxOpen}
                                    setHoverIndex={setHoverIndex}
                                    setColorIndexID={setColorIndexID}
                                    setActivePatch={setActivePatch}
                                    hoverIndex={hoverIndex}
                                    colorIndexID={colorIndexID}
                                    activePatch={activePatch}
                                    clickTimeoutRef={clickTimeoutRef}
                                    ignoreNextClickRef={ignoreNextClickRef}
                                    handleEditTitle={handleEditTitle}
                                    clearHighlight={clearHighlight}
                                    handleClick={handleClick}
                                    setUpdateTitle={setUpdateTitle}
                                    updateTitle={updateTitle}
                                    setIsOpenDeadline={setIsOpenDeadline}
                                    isOpenDeadline={isOpenDeadline}
                                    isSearchBoxOpen={isSearchBoxOpen}
                                    deleteTask={deleteTaskMail}
                                    taskToDelete={taskToDelete}
                                    setTaskToDelete={setTaskToDelete}
                                    selectedBoardId={selectedBoardId}
                                    handleCancelDelete={handleCancelDelete}
                                    {...taskData}
                                    allTaskData={taskMail}
                                    setTaskMail={setTaskMail}
                                    moveTask={moveTask}
                                    hoveredIndex={hoveredIndex}
                                    setHoveredIndex={setHoveredIndex}
                                    moveTaskToIndex={moveTaskToIndex}
                                    updateStatusTask={updateStatusTask}
                                    createTaskMail={createTaskMail}
                                    setStatusUpdate={setStatusUpdate}
                                    moveTaskInState={moveTaskInState}
                                    moveTaskToOtherColumnInState={moveTaskToOtherColumnInState}
                                    isArchivedBoard={isArchivedBoard}
                                    supervisorActions={supervisorActions}
                                    allCustomFieldList={allCustomFieldList}
                                />
                            ))}
                        {permissions.addTask && (
                            <div
                                className="task task-curve"
                                style={hoveredIndex === (taskMail[columnID] || []).length ? { marginTop: '40px' } : {}}
                            >
                                <button
                                    style={{ opacity: '0.3' }}
                                    onClick={() => {
                                        setSelectedStatus(columnID);
                                        addNewForm('column-list');
                                    }}
                                    className="add-task-button"
                                >
                                    <FontAwesomeIcon icon={faPlus} />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {deleteShowBox && (
                <ConfirmationPopup
                    customMessage={deleteMessage}
                    boardName={columnTitle}
                    taskToDeleteId={''}
                    onCancel={() => setDeleteShowBox(false)}
                    deleteTaskMail={deleteTaskMail}
                />
            )}
            <div>
                {automations && step === 1 && (
                    <AllAutomation
                        show={automations}
                        onHide={() => {
                            setAutomations(false);
                            setStep(1);
                        }}
                        step={step}
                        setStep={setStep}
                        setAutomations={setAutomations}
                        editId={editId}
                        setEditId={setEditId}
                    />
                )}
                {automations && step === 2 && (
                    <Automations
                        show={automations}
                        setAutomations={setAutomations}
                        onHide={() => {
                            setAutomations(false);
                            setStep(1);
                        }}
                        boardName={boardName}
                        gmailUsers={filterList}
                        step={step}
                        setStep={setStep}
                        editId={editId}
                        setEditId={setEditId}
                    />
                )}
                {incomingEmailAutomation && (
                    <AllIncomingAutomation
                        show={incomingEmailAutomation}
                        step={columnStep}
                        setStep={setColumnStep}
                        editId={columneditId}
                        setEditId={setColumnEditId}
                        setIncomingEmailAutomation={setIncomingEmailAutomation}
                        onHide={() => {
                            getAllAutomation()
                            setColumnEditId(null)
                            setIncomingEmailAutomation(false)
                        }}
                    />
                )}
                {columnAutomations && (
                    <IncomingMail
                        show={columnAutomations}
                        setAutomations={setColumnAutomations}
                        onHide={() => {
                            setColumnAutomations(false)
                            setColumnStep(1)
                            if(columnAutomation.length>0){
                                setIncomingEmailAutomation(true)
                            }

                        }}
                        getAllAutomation={getAllAutomation}
                        step={columnStep}
                        setStep={setColumnStep}
                        editId={columneditId}
                        setEditId={setColumnEditId}
                    />
                )}
            </div>
            <Tooltip id="matched-email-tooltip" place="top" />

        </>
    );
}

export default Column;
